import { SustainabilityMatterId } from '@upright/common/model/input/materiality-assessment/types-matters';
import { ModelEntityType, CompanyLikeEntityType } from '@upright/common/model/input/types';

export type MatrixMattersByBucket = {
  [key in MatterBucketId]: MatrixMatter[];
};

export type MatrixMatter = {
  matterId: SustainabilityMatterId;
  positive: MatrixValuesOfValence | null;
  negative: MatrixValuesOfValence | null;
};

export type MatrixValuesOfValence = {
  imLevel: MaterialityMatrixLevel;
  imScore: number;
  fmLevel: MaterialityMatrixLevel;
  isMaterial: boolean;
};

export const allMatrixLevels = ['low', 'medium', 'high'] as const;
export type MaterialityMatrixLevel = (typeof allMatrixLevels)[number];

export type MatterBucketId = `im-${MaterialityMatrixLevel}:fm-${MaterialityMatrixLevel}`;
export const allBuckets = allMatrixLevels
  .map(imLevel => allMatrixLevels.map((fmLevel): MatterBucketId => `im-${imLevel}:fm-${fmLevel}`))
  .flat();

export type MatrixEntityMetaDataByType = {
  [ModelEntityType.COMPANY]: MatrixCompanyVariantMetaData;
  [ModelEntityType.GROUP]: MatrixWeightSetMetaData;
  [ModelEntityType.PORTFOLIO]: MatrixWeightSetMetaData;
};

type MatrixCompanyVariantMetaData = {
  type: 'company';
  variantId: string;
  productDataVersion: string;
  release: string;
};

type MatrixWeightSetMetaData = {
  type: 'groupfolio';
  weightSetResultId: number;
  release: string;
};

export function isCompanyVariantMatrixData(
  data: MatrixEntityMetaDataByType[CompanyLikeEntityType],
): data is MatrixCompanyVariantMetaData {
  return data.type === 'company';
}
